module.exports = __webpack_public_path__ + "./fonts/PPAgrandir-GrandHeavy.otf";